import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.button `
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--colorPrimary);
  background: none;
  background-image: linear-gradient(to right, var(--colorPrimary), var(--colorPrimary));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  color: var(--colorPrimary);
  height: 67px;
  padding: 0px 24px 0px 40px;
  text-decoration: none;
  transition: background-size 0.15s ${cubicEaseOut}, border-color 0.15s ${cubicEaseOut};
  user-select: none;
  width: auto;

  &[data-fill='right'] {
    background-position: left center;
  }

  &[data-fill='left'] {
    background-position: right center;
  }
  
  span& {
    button:focus &,
    a:focus & {
      outline: auto;
      outline-offset: 3px;
    }

    button:hover &,
    a:hover & {
      color: var(--colorContrast);
      background-size: 100% 100%;
    }

    button[data-type='solid']:hover &,
    a[data-type='solid']:hover & {
      color: var(--colorContrast);
      background-size: 0% 100%;
    }
  }

  &:not(span) {
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &:focus {
      outline: auto;
      outline-offset: 5px;
    }

    &:hover {
      color: var(--colorContrast);
      background-size: 100% 100%;
    }

    &[data-type='solid']:hover,
    &[data-type='solid-inverted']:hover {
      color: var(--colorPrimary);
      background-size: 0% 100%;
    }
  }

  &[data-type='default'] {
    --colorPrimary: ${brand.grey.grey6};
    --colorContrast: ${brand.white};
  }

  &[data-type='inverted'] {
    --colorPrimary: ${brand.white};
    --colorContrast: ${brand.grey.grey6};
  }

  &[data-type='solid'] {
    --colorPrimary: ${brand.grey.grey6};
    --colorContrast: ${brand.white};
    background-size: 100% 100%;
    color: var(--colorContrast);
  }

  &[data-type='solid-inverted'] {
    --colorPrimary: ${brand.white};
    --colorContrast: ${brand.grey.grey6};
    background-size: 100% 100%;
    color: var(--colorContrast);
  }

  &[data-icon-only='true'] {
    height: 78px;
    justify-content: center;
    padding: 0;
    width: 78px;
  }

  /* Increase specificity to override :not(span) style */
  &:disabled:disabled:disabled {
    --colorPrimary: ${brand.grey.grey3};
    --colorContrast: ${brand.grey.grey3};
    background-size: 0% 100%;
    pointer-events: none;
  }

  &[data-type='solid']:disabled:disabled:disabled {
    --colorPrimary: ${brand.grey.grey3};
    --colorContrast: ${brand.white};
    background-size: 100% 100%;
    pointer-events: none;
  }

  @media ${until(Device.TabletLarge)} {
    height: 45px;
    padding: 0px 12px;

    &[data-icon-only='true'] {
      height: 45px;
      width: 45px;
    }
  }
`;
const Text = styled.span `
  color: currentColor;
  ${fonts.body.medium};
  font-size: 16px;
  line-height: 1em;
  text-decoration: none;
  transition: color 0.15s ${cubicEaseOut};

  [data-icon-only='true'] & {
    ${srOnly};
  }
`;
const IconWrapper = styled.div `
  display: block;
  color: currentColor;
  height: 17px;
  margin: 0;
  padding: 0;
  transition: color 0.15s ${cubicEaseOut};
  width: 37px;

  [data-icon-position='left'] & {
    margin-right: auto;
    order: -1;
    padding-right: 20px;
  }

  [data-icon-position='right'] & {
    margin-left: auto;
    order: 1;
    padding-left: 20px;
  }

  [data-icon-only='true'] & {
    color: currentColor;
    height: 17px;
    margin: 0;
    padding: 0;
    width: 17px;
  }
`;
const ButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default ButtonStyles;
